import {
  CloseButton,
  Description,
  ModalBackground,
  ModalWrapper,
  Title,
  ModalContent,
} from "./style";
import React from "react";
interface IProps {
  title: string;
  description: string;
  onClose: () => void;
}

export const Modal = ({ title, description, onClose }: IProps) => {
  return (
    <ModalBackground>
      <ModalWrapper>
        <CloseButton onClick={onClose}>x</CloseButton>
        <ModalContent>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </ModalContent>
      </ModalWrapper>
    </ModalBackground>
  );
};
